import * as React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { Row, Button, Switch, Tabs, Input, Col, Space } from "antd";
import { notificationSuccess } from "utils/libHelpers/AntdNotification";
import { LinkLanguage, releaseNotesStore } from "./ReleaseNotesStore";
import { useNavigate } from "react-router";

export const ReleaseNotes = observer(() => {
  const [activeKey, setActiveKey] = React.useState("DE");
  const { t } = useTranslation([I18N_NS.PROJECT, I18N_NS.GENERAL]);
  const navigate = useNavigate();

  const handleEdit = async () => {
    try {
      await releaseNotesStore.edit();
      notificationSuccess(t(`${I18N_NS.GENERAL}:::Success`), t(`${I18N_NS.GENERAL}:::Link saved`));
    } catch (error) {
      console.warn("Sorry something went wrong");
    }
  };

  const handleSwitch = (checked: boolean) => {
    releaseNotesStore.switch(checked);
  };

  const renderEditor = (
    data: API_ReleaseNotes,
    lang: LinkLanguage,
    onEdit: (lang: LinkLanguage, prop: keyof API_ReleaseNotes, value: string) => void
  ) => {
    return (
      <Row justify="space-between" align="middle" gutter={12}>
        <Col flex="1">
          <Space.Compact>
            <span>{t("Link name")}</span>
            <Input
              value={data.linkName}
              onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                onEdit(lang, "linkName", target.value);
              }}
            />
          </Space.Compact>
        </Col>
        <Col flex="1">
          <Space.Compact>
            <span>{t("Link target")}</span>
            <Input
              value={data.linkTarget}
              onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => onEdit(lang, "linkTarget", target.value)}
            />
          </Space.Compact>
        </Col>
      </Row>
    );
  };
  const pages = [
    {
      label: "DE",
      language: "DE",
      component: renderEditor(releaseNotesStore.data.de, "de", releaseNotesStore.setData),
    },
    {
      label: "EN",
      language: "EN",
      component: renderEditor(releaseNotesStore.data.en, "en", releaseNotesStore.setData),
    },
  ];

  React.useEffect(() => {
    (async () => {
      await releaseNotesStore.fetch();
    })();
  }, []);

  return (
    <div className="g-card">
      <Tabs
        activeKey={activeKey}
        onChange={setActiveKey}
        tabBarExtraContent={
          <div>
            {t("Activate")}
            <Switch checked={releaseNotesStore.active} onChange={handleSwitch} style={{ marginLeft: `10px` }} />
          </div>
        }
        items={pages.map(({ label, component }) => ({
          key: label,
          label: t(`${I18N_NS.GENERAL}:::${label}`),
          children: component,
        }))}
      />
      <Row justify="space-between" style={{ marginTop: "20px" }}>
        <Button onClick={() => navigate("/admin")}>{t(`${I18N_NS.GENERAL}:::Cancel`)}</Button>
        <Button type="primary" onClick={handleEdit}>
          {t("Save")}
        </Button>
      </Row>
    </div>
  );
});
